export const ReloadEvent = new Event("reload:react");
